module.exports = __webpack_public_path__ + "img/landing-1-en-US.da92a16.png";